import { isTMA } from "@telegram-apps/sdk-react";

export let IS_TELEGRAM_WEB_APP = false;

export async function initConstants() {
  try {
    IS_TELEGRAM_WEB_APP = isTMA() && (await isTMA("complete"));
  } catch {
    IS_TELEGRAM_WEB_APP = false;
  }
}
